import React from "react";
import { LegalLayout, Section } from "@/components/legal/LegalLayout";

const P: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="text-[color:var(--sg-fg)] leading-relaxed">{children}</p>
);

export const RefundPolicy: React.FC = () => (
  <LegalLayout
    testId="page-refunds"
    title="Refund Policy"
    subtitle="Our transparent approach to refunds and cancellations."
    lastUpdated="February 13, 2026"
    seoPath="/refunds"
    seoDescription="SociBaba refund and cancellation policy — 14-day annual guarantee, monthly cancellations, and process."
    seoKeywords={["refund policy","cancellation","money-back guarantee","subscription refund"]}
  >
    <Section n={1} title="Monthly plans">
      <P>
        Monthly subscription fees are non-refundable once billed. You may cancel at any time from Settings → Billing, and your workspace will continue to have access until the end of the current billing cycle.
      </P>
    </Section>

    <Section n={2} title="Annual plans — 14-day money-back guarantee">
      <P>
        For annual plans, we offer a 14-day money-back guarantee. If you cancel within 14 days of your initial annual subscription, email <a className="text-[color:var(--sg-primary)] hover:underline" href="mailto:billing@socibaba.com">billing@socibaba.com</a> and we will refund the full amount.
      </P>
    </Section>

    <Section n={3} title="Exceptions">
      <P>Refunds may be declined if:</P>
      <ul className="list-disc ml-6 space-y-1 mt-2">
        <li>The account has been used in violation of our Terms of Service.</li>
        <li>The request is made outside the applicable refund window above.</li>
        <li>Refund fraud or abuse is suspected.</li>
      </ul>
    </Section>

    <Section n={4} title="Failed publishes and third-party outages">
      <P>
        SociBaba fees are for platform access, not per-publish. Failed publishes to third-party platforms (YouTube, Meta) due to their API outages, policy actions, or account issues are not grounds for a refund. We retry failed jobs automatically via the Retry Center.
      </P>
    </Section>

    <Section n={5} title="How to request a refund">
      <P>
        Email <a className="text-[color:var(--sg-primary)] hover:underline" href="mailto:billing@socibaba.com">billing@socibaba.com</a> from the account's registered email with the subject "Refund Request". Include your workspace name and reason. We respond within 3 business days.
      </P>
    </Section>
  </LegalLayout>
);

export default RefundPolicy;
